import React from 'react';
import NavbarAccount from '../../components/NavbarAccount';
import Account from '../Account';
import { UserAuth } from '../../context/AuthContext';
import { Navigate } from "react-router-dom";

const Home = () => {

  const { currentUser } = UserAuth();
  console.log(currentUser)
  
  return currentUser ? (
    <div>
      <NavbarAccount />
      <Account />
    </div>
  ) : (
    <Navigate to="/signup" />
  );
  //   return (
  //   <div>
  //     <NavbarAccount />
  //     <Account />
  //   </div>
  // )
}

export default Home;